import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Rechnungsvertrag {
  id: string;
  standort_id?: string;
  kunde_id?: string;
  hausverwaltung_id?: string;
  erf_nr: string;
  alte_kundennummer?: string;
  rg_intervall_type?: string;
  rg_anchor_month?: number;
  rg_intervall_raw?: string;
  abrechnung_intervall_raw?: string;
  vk_wert_netto?: number;
  vk_wert_brutto?: number;
  letzte_rechnung_nr?: string;
  kd_bestellnr?: string;
  zahlungsziel_tage?: number;
  rg_adresse_zeile1?: string;
  rg_adresse_zuhanden?: string;
  rg_adresse_zusatzname?: string;
  service_artikel_nummer?: string;
  start_datum?: string;
  aktiv?: number;
  created_at?: string;
  updated_at?: string;

  // Relations (loaded via with())
  standort?: any;
  kunde?: any;
  hausverwaltung?: any;
}

export interface RechnungsvertragListResponse {
  result: number;
  data: Rechnungsvertrag[];
  total?: number;
  error?: string;
  sec: string;
}

export interface RechnungsvertragSingleResponse {
  result: number;
  data: Rechnungsvertrag;
  error?: string;
  sec: string;
}

export interface RechnungsvertragFilter {
  standort_id?: string;
  kunde_id?: string;
  hausverwaltung_id?: string;
  erf_nr?: string;
}

@Injectable({ providedIn: 'root' })
export class RechnungsvertragService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getRechnungsvertraege(filter: RechnungsvertragFilter = {}): Observable<RechnungsvertragListResponse> {
    const params: any = {};
    if (filter.standort_id) params.standort_id = filter.standort_id;
    if (filter.kunde_id) params.kunde_id = filter.kunde_id;
    if (filter.hausverwaltung_id) params.hausverwaltung_id = filter.hausverwaltung_id;
    if (filter.erf_nr) params.erf_nr = filter.erf_nr;
    return this.http.get<RechnungsvertragListResponse>(`${this.apiUrl}/rechnungsvertrag`, { params });
  }

  getRechnungsvertrag(id: string): Observable<RechnungsvertragSingleResponse> {
    return this.http.get<RechnungsvertragSingleResponse>(`${this.apiUrl}/rechnungsvertrag/${id}`);
  }

  updateRechnungsvertrag(id: string, data: Partial<Rechnungsvertrag>): Observable<RechnungsvertragSingleResponse> {
    return this.http.put<RechnungsvertragSingleResponse>(`${this.apiUrl}/rechnungsvertrag/${id}`, data);
  }

  createRechnungsvertrag(data: Partial<Rechnungsvertrag>): Observable<RechnungsvertragSingleResponse> {
    return this.http.post<RechnungsvertragSingleResponse>(`${this.apiUrl}/rechnungsvertrag`, data);
  }
}
